<mat-nav-list class="sd_bar">
  <div class="logo-brand">
    <figure class="logo"><img src={{assetsConst.logo}} alt="logo" /></figure>
    <button (click)="toggleSidenav()" class="btnn btn_close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="side-scroll">
    <div *ngFor="let item of sideBar">
      <ng-container *ngIf="!item.isSubMenu">
        <mat-list-item [routerLink]="item.path" routerLinkActive="active" disableRipple>
          <figure class="sd_cn" matTooltip="{{item.text  | translate}}">
            <img src="{{item.img}}" alt="" />
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.text | translate }}</h5>
          </div>
        </mat-list-item>
      </ng-container>
      <mat-accordion *ngIf="item.isSubMenu">
        <mat-expansion-panel class="drop_lst_nv">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-list-item disableRipple>
                <figure class="sd_cn" mat-raised-button matTooltip="{{item.text | translate}}">
                  <img src="{{item.img}}" alt="" />
                </figure>

                <div class="sidenav-item">
                  <h5 class="lead">{{ item.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list-item *ngFor="let sub of item.subMenuItems" [routerLink]="sub.path" disableRipple>
            <figure class="sd_cn" matTooltip="{{ item.text }}" matTooltip="{{item.text | translate}}">
              <img src="{{sub.img}}" alt="images">
            </figure>
            <div class="sidenav-item">
              <h5 class="lead">{{ sub.text | translate }}</h5>
            </div>
          </mat-list-item>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</mat-nav-list>
